<template>
  <div class="status-banner" role="status"><slot /></div>
</template>

<style scoped>
  .status-banner {
    background: var(--color-surface);
    border-bottom: 2px solid var(--color-primary);
    color: var(--color-primary);
    flex-shrink: 0;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-strong);
    letter-spacing: 0.1rem;
    padding: 0.5rem var(--view-gutter);
    text-align: center;
    text-transform: uppercase;
  }
</style>
